var _defs, _path, _path2, _path3, _g, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGerontologieSmallRgbB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.14 277.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #487fb0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.29,5.02V0l-80.28.73-9.98,1.79C46.75,16.3,0,71.92,0,138.29c0,76.7,62.4,139.1,139.1,139.1s137.79-61.15,139.04-136.78h-5.02c-1.25,72.86-60.87,131.76-134.02,131.76S5.02,212.23,5.02,138.29C5.02,69.8,56.64,13.18,123.02,5.21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.02,20.7C60.29,31.9,18.96,80.3,18.96,138.29c0,66.25,53.9,120.15,120.15,120.15s118.84-52.64,120.09-117.82h-5.02c-1.25,62.41-52.37,112.8-115.07,112.8S23.97,201.77,23.97,138.29c0-55.55,39.58-101.91,91.99-112.66h103.45v-5.02h-96.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.3,140.62c-1.25,52.58-44.32,94.99-97.2,94.99s-97.31-43.65-97.31-97.31c0-47.32,34.01-86.68,78.84-95.36h112.72v-5.02h-110.33c-1.09-.05-1.86-.09-2.78.08l-.89.11h0c-46.97,9.25-82.58,50.54-82.58,100.18,0,56.42,45.9,102.33,102.33,102.33s100.96-44.66,102.21-100h-5.02Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 123.02,
    y: 54.77,
    width: 131.53,
    height: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.1,218.29c-44.11,0-80-35.89-80-80,0-38.61,27.49-71.04,63.92-78.51v-5.02c-39.21,7.54-68.94,42.15-68.94,83.52,0,46.88,38.14,85.02,85.02,85.02s83.66-36.9,84.91-82.7h-5.02c-1.25,43.03-36.56,77.68-79.89,77.68Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.68,78.87v-5.02H123.02v.13h0v-.13c-.15.04-.3.09-.46.13h-.07v.02c-28.71,7.41-50.01,33.29-50.01,64.28,0,36.74,29.89,66.62,66.62,66.62s65.27-28.64,66.51-64.3h-5.02c-1.24,32.89-28.3,59.28-61.49,59.28s-61.6-27.64-61.6-61.6c0-28.4,19.34-52.3,45.52-59.4v-.26h0v.25h149.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGerontologieSmallRgbB);
export default __webpack_public_path__ + "static/media/Gerontologie_Small_RGB_B.aa42e0255e3b84145086c3becc44d888.svg";
export { ForwardRef as ReactComponent };